import type React from 'react';

import { Button, Modal, ModalBody, ModalHeader, Text } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core-react/i18n';

import { useCancelSubscriptionUpsellModal } from './hooks/useCancelSubscriptionUpsellModal';

export const CancelSubscriptionUpsellModal: React.FC<{ trigger: JSX.Element }> = ({ trigger }) => {
	const { translate } = useI18n();
	const {
		data: { title, text, cancelLabel, lowerLabel, lowerByHalfLoading, cancelLoading },
		actions: { clickLowerByHalf, clickCancelSubscription, resetState, clickClose },
	} = useCancelSubscriptionUpsellModal();

	return (
		<Modal
			trigger={trigger}
			onClose={clickClose}
			closeButtonAriaLabel={translate('corgi.components.modal.close_button')}
			className="z-999 *:min-h-[125px]!"
			size="small"
		>
			<ModalHeader title={<Text size="x-small">{title}</Text>} />
			<ModalBody>
				{({ close }) => (
					<div className="mx-auto flex flex-col items-center">
						<Text size="medium">{text}</Text>
						<div className="mt-6 flex w-full flex-col gap-4 p-1">
							<Button
								data-qa="subscription-cancellation-modal-button-lower-amount"
								data-testid="button-confirm"
								onClick={async () => {
									await clickLowerByHalf();
									close();
									resetState();
								}}
								loading={lowerByHalfLoading}
								variant="primary"
								size="small"
							>
								{lowerLabel}
							</Button>
							<Button
								data-qa="subscription-cancellation-modal-button-confirm"
								data-testid="button-cancel"
								onClick={async () => {
									await clickCancelSubscription(() => close());
									close();
									resetState();
								}}
								loading={cancelLoading}
								variant="secondary"
								size="small"
							>
								{cancelLabel}
							</Button>
						</div>
					</div>
				)}
			</ModalBody>
		</Modal>
	);
};
